import firebase from "datastore/database";
import store from "datastore/store";

const dispatchError = () => store.dispatch({ type: "ADD_AUTHED_USER_ERROR" });

export default function observeUser(userUid) {
  store.dispatch({ type: "ADD_AUTHED_USER_LOADING" });

  return firebase
    .firestore()
    .collection("users")
    .doc(userUid)
    .onSnapshot((doc) => {
      if (!doc.exists) {
        dispatchError();
        return;
      }

      let user = { uid: doc.id, ...doc.data() };

      user = {
        ...user,
        ...(user.role === "root" && { rootUser: true }),
      };

      store.dispatch({
        type: "ADD_AUTHED_USER_SUCCESS",
        user,
      });
    });
}
